var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pn_bg",class:{ show: _vm.open }},[_c('div',{attrs:{"id":"pn"}},[_c('h5',[_vm._v(_vm._s(_vm.editTitle))]),_vm._t("default")],2),_c('div',{staticClass:"close_bg",on:{"click":_vm.closePn}})])
}
var staticRenderFns = []

export { render, staticRenderFns }